"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractOwner = exports.SearchFlags = exports.SourceReferralDealType = exports.SourceState = void 0;
var SourceState;
(function (SourceState) {
    SourceState["Active"] = "active";
    SourceState["Darklaunch"] = "darklaunch";
    SourceState["Disabled"] = "disabled";
})(SourceState = exports.SourceState || (exports.SourceState = {}));
var SourceReferralDealType;
(function (SourceReferralDealType) {
    SourceReferralDealType["Cart"] = "cart";
})(SourceReferralDealType = exports.SourceReferralDealType || (exports.SourceReferralDealType = {}));
var SearchFlags;
(function (SearchFlags) {
    SearchFlags["NoComputedRountripsWithSelf"] = "no_computed_roundtrips_with_self";
})(SearchFlags = exports.SearchFlags || (exports.SearchFlags = {}));
var ContractOwner;
(function (ContractOwner) {
    ContractOwner["BUSBUD_INC"] = "busbud_inc";
    ContractOwner["BUSBUD_MEXICO"] = "busbud_mexico";
    ContractOwner["BUSBUD_ARGENTINA"] = "busbud_argentina";
    ContractOwner["BUSBUD_BRASIL"] = "busbud_brasil";
})(ContractOwner = exports.ContractOwner || (exports.ContractOwner = {}));
//# sourceMappingURL=sources.js.map